import { render, staticRenderFns } from "./CollapsablePanel.vue?vue&type=template&id=1361470c&scoped=true&name=collapsable-panel&"
import script from "./CollapsablePanel.vue?vue&type=script&lang=js&"
export * from "./CollapsablePanel.vue?vue&type=script&lang=js&"
import style0 from "./CollapsablePanel.vue?vue&type=style&index=0&id=1361470c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1361470c",
  null
  
)

export default component.exports